import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import Chip from 'Chip';
import styles from './index.css';

import { Dialog } from '../../../../../components/modal';

class Judges extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    /**
     * 插入html
     */

    handleClickRule = () => {
        const { content } = this.props;

        // console.log(content, curArea);

        if (content && content.imgUrl) {
            Dialog.show({
                title: '评委阵容',
                content: <img className={styles.judgesImg} src={content.imgUrl} alt="" />,
            });
        } else {
            alert('暂无');
        }
    };

    render() {
        return (
            <div className={styles.other} onClick={this.handleClickRule}>
                评委阵容
            </div>
        );
    }
}

const JudgesChip = props => (
    <Chip id="230217" type="struct" title="美食盛典-美食评委" groupName="正文-美食盛典" content={props.content}>
        <Judges />
    </Chip>
);

JudgesChip.propTypes = {
    content: PropTypes.object,
};

export default errorBoundary(JudgesChip);
